const SuccessIcon = () => (
    <div
        className="w-11 h-11 rounded-[30%] grid place-items-center shrink-0"
        style={{
            background: 'linear-gradient(135deg, #46e08a, #2bb89b)',
            boxShadow:
                '0 0 22px -2px rgba(70,224,138,0.7), inset 0 1px 0 rgba(255,255,255,0.35)',
        }}
        aria-label="Success"
    >
        <svg
            viewBox="0 0 24 24"
            className="w-6 h-6 stroke-white fill-none [stroke-width:2.8] [stroke-linecap:round] [stroke-linejoin:round]"
        >
            <path d="M5 12l4 4 10-10" />
        </svg>
    </div>
);

export default SuccessIcon;
